import React from 'react';
import { FormModal, Icon, Text, notify } from '@shootsta/common-react';
import '../styles/_duplicate-modal.scss';

type DuplicateModalProps = {
  visible: boolean;
  duplicateVideo: any;
  onConfirmation: any;
  onClose: any;
  video?: Video;
};

const WARNINGS_LIST = [
  'The project brief',
  'All video outputs, as a draft version',
  'All video clips and assets'
];

const handleSave = async (video, duplicateVideo: any, onConfirmation: any) => {
  const { name, videoId } = video;

  notify({ content: `We're duplicating ${name}.`, type: 'info' });

  const { data, error } = await duplicateVideo(videoId);

  if (!data || !data.duplicateVideo || error) {
    return null;
  }

  return onConfirmation();
};

function DuplicateModal({
  visible,
  video,
  onClose,
  duplicateVideo,
  onConfirmation
}: DuplicateModalProps) {
  if (!video) {
    return null;
  }

  return (
    <FormModal
      visible={visible}
      onClose={onClose}
      onSave={() => handleSave(video, duplicateVideo, onConfirmation)}
      title="Duplicate Project"
      saveText="Duplicate"
    >
      <Text heading5>{video && video.name}</Text>
      <Text>Duplicating this project will duplicate the following:</Text>
      {WARNINGS_LIST.map((warning) => (
        <div key={warning} className="duplicate-modal__warnings">
          <Icon name="alert" color="goldenTainoi" size={20} />
          <Text>{warning}</Text>
        </div>
      ))}
    </FormModal>
  );
}

export default DuplicateModal;
